import VolumeDown from "@mui/icons-material/VolumeDown";
import VolumeUp from "@mui/icons-material/VolumeUp";
import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import Slider from "@mui/material/Slider";
import Stack from "@mui/material/Stack";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ArrowDown from "../../../SVGs/ArrowDown";
import Emoji9 from "../../../SVGs/Emoji9";
import HalfStar from "../../../SVGs/HalfStar";
import InsertEmoji from "../../../SVGs/InsertEmoji";
import SendBtn from "../../../SVGs/SendBtn";
import SortIcon from "../../../SVGs/SortIcon";
import UserAvatar from "../../../components/UserAvatar";
import { postReacts, reactsIds } from "../../../config/reacts";
import { postReact } from "../../../services/timeline";
import { CHANGE_REACT } from "../../../store/actions/types";
import { createNewCommentAction } from "../../../store/actions/video/comments";

function Overlay({ volume, handleVolumeChange }) {
  const dispatch = useDispatch();
  const timeoutRef = useRef(null);

  const [currentPostReacts, setCurrentPostReacts] = useState([]);
  const [comment, setComment] = useState("");
  const [messages, setMessages] = useState([]);
  const [openEmojis, setOpenEmojis] = useState(false);
  const [loading, setLoading] = useState();
  const [reacting, setReacting] = useState(false);

  const post = useSelector((s) => s?.video?.post);
  const isAuthenticated = useSelector((s) => s.auth.isAuthenticated);
  const postId = post?.id;

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  const reactionClicked = useCallback(
    (reactId) => {
      if (reacting) return;
      let shouldDelete = parseInt(post?.userReaction) === parseInt(reactId);
      setReacting(true);
      postReact({
        postId,
        reactionTypeId: reactId,
        deleteReact: shouldDelete,
        cb: () => {
          setReacting(false);
          dispatch({
            type: CHANGE_REACT,
            payload: {
              reactionTypeId: reactId,
              deleteReact: shouldDelete,
              postId,
            },
          });
        },
      });
      setOpenEmojis(false);
    },
    [dispatch, postId, reacting, post?.userReaction]
  );

  const createPost = useCallback(() => {
    setLoading(true);
    let allFiles = [];

    if (postId) {
      return createNewCommentAction({
        files: allFiles,
        text: comment,
        postId,
        cb: (err, data) => {
          setLoading(false);
          if (!err) {
            const newMessages = [...messages, data];

            if (newMessages.length > 4) {
              newMessages.shift();
            }

            setMessages(newMessages);
            setComment("");
          }
        },
      })(dispatch);
    }
  }, [dispatch, postId, comment, messages]);

  const handleSendMessage = () => {
    if (comment.trim() !== "") {
      createPost();

      setOpenEmojis(false);
    }
  };

  useEffect(() => {
    if (messages.length > 0) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setMessages((previousMessages) => previousMessages.slice(1));
      }, 5000);
    }
  }, [messages]);

  useMemo(() => {
    let allReacts = [];
    Object.keys(post?.reacts || {})
      ?.filter((r) => post?.reacts[r] !== 0 && r !== "total")
      .map((reactId) => allReacts.push(reactId));
    setCurrentPostReacts(allReacts);
  }, [post?.reacts]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        left: "0",
        right: "0",
        top: "0",
        bottom: "0",
        padding: { xs: "1em 1em 0.5em 1em", sm: "2em 2em 0.5em 2em" },
        position: "absolute",
        gap: "1em",
        justifyContent: "end",
      }}
    >
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: { xs: "1em", md: "2em", lg: "3em", xl: "4em" },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            zIndex: 2,
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: "1em",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                width: {
                  xs: "30px",
                  sm: "40px",
                  md: "50px",
                  lg: "60px",
                  xl: "80px",
                },
              }}
            >
              <Live />
            </Box>
            <Box
              sx={{
                width: {
                  xs: "14px",
                  sm: "16px",
                  md: "18px",
                  lg: "20px",
                  xl: "22px",
                },
              }}
            >
              <Eye />
            </Box>
            <Typography
              sx={{
                fontSize: {
                  xs: "10px",
                  sm: "12px",
                  md: "14px",
                  lg: "16px",
                  xl: "18px",
                },
                color: "white",
                pointerEvents: "none",
              }}
            >
              23k Views
            </Typography>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "1em",
              color: "#ffffff",
            }}
          >
            <Typography
              sx={{
                fontSize: {
                  xs: "12px",
                  sm: "14px",
                  md: "16px",
                  lg: "20px",
                  xl: "25px",
                },
                pointerEvents: "none",
              }}
            >
              Randa Tarek
            </Typography>
            <Box
              sx={{
                stroke: "#ffffff",
                width: { xs: "20px", md: "25px" },
              }}
            >
              <Competition />
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: { xs: "end", sm: "space-between" },
          }}
        >
          <Typography
            sx={{
              color: "#ffffff",
              pointerEvents: "none",
              zIndex: 2,
              display: { xs: "none", sm: "block" },
              fontSize: {
                sm: "20px",
                md: "25px",
                lg: "30px",
                xl: "50px",
              },
            }}
          >
            Adventure
          </Typography>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: { xs: "0.5em", sm: "1em", md: "2em" },
              zIndex: 20,
            }}
          >
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "50%",
                width: {
                  xs: "25px",
                  sm: "40px",
                  md: "45px",
                  lg: "50px",
                  xl: "60px",
                },
                height: {
                  xs: "25px",
                  sm: "40px",
                  md: "45px",
                  lg: "50px",
                  xl: "60px",
                },
                stroke: "#323232",
                transition: "0.5s all",
                "&:hover": {
                  backgroundColor: "#D5F3FF",
                  stroke: "#25AAE1",
                },
              }}
            >
              <TranslateBtn />
            </IconButton>
            <IconButton
              sx={{
                backgroundColor: "#ffffff",
                borderRadius: "50%",
                width: {
                  xs: "25px",
                  sm: "40px",
                  md: "45px",
                  lg: "50px",
                  xl: "60px",
                },
                height: {
                  xs: "25px",
                  sm: "40px",
                  md: "45px",
                  lg: "50px",
                  xl: "60px",
                },
                fill: "#323232",
                transition: "0.5s all",
                "&:hover": {
                  backgroundColor: "#D5F3FF",
                  fill: "#25AAE1",
                },
              }}
            >
              <CustomerService />
            </IconButton>
          </Box>
        </Box>
      </Box> */}

      <Box
        sx={{
          display: { xs: "none", sm: "flex" },
          flexDirection: "column",
          gap: "0.5em",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "start",
            alignItems: "middle",
            gap: "1em",
            zIndex: 20,
          }}
        >
          {messages.map((comment, index) => {
            let creator = comment?.creator;
            return (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "middle",
                  gap: "1em",
                  backgroundColor: "rgba(255, 255, 255, 0.74)",
                  padding: "0.5em",
                  maxWidth: "40%",
                  borderTopRightRadius: "10px",
                  borderBottomRightRadius: "10px",
                  borderBottomLeftRadius: "10px",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    gap: "0.5em",
                  }}
                >
                  <UserAvatar
                    src={creator?.image}
                    alt={
                      creator?.firstName + creator?.lastName ||
                      creator?.username
                    }
                    color={creator?.color}
                    sx={{
                      "&:hover": {
                        cursor: "pointer",
                      },
                    }}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "start",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#323232",
                        pointerEvents: "none",
                      }}
                    >
                      {creator?.firstName + creator?.lastName ||
                        creator?.username}
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{
                        color: "#6C6C6C",
                        pointerEvents: "none",
                        wordBreak: "break-word",
                      }}
                    >
                      {comment?.text}
                    </Typography>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#323232",
                        textDecoration: "underline",
                        textTransform: "none",
                        transition: "0.5s all",
                        "&:hover": {
                          color: "#25AAE1",
                          textDecoration: "underline",
                          cursor: "pointer",
                        },
                      }}
                    >
                      Reply
                    </Typography>
                  </Box>
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "start",
                    gap: "1em",
                  }}
                >
                  <Typography
                    variant="body1"
                    sx={{ color: "#7A7A7A", pointerEvents: "none" }}
                  >
                    at 06.43min
                  </Typography>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Box
                      sx={{
                        fill: "#7A7A7A",
                        transition: "0.5s all",
                        "&:hover": {
                          fill: "#25AAE1",
                          cursor: "pointer",
                        },
                      }}
                    >
                      <HalfStar />
                    </Box>
                    <Typography
                      variant="caption"
                      sx={{ color: "#7A7A7A", pointerEvents: "none" }}
                    >
                      23
                    </Typography>
                  </Box>
                </Box>
              </Box>
            );
          })}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "middle",
              zIndex: 20,
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "1em",
                width: "70%",
              }}
            >
              <TextField
                disabled={loading}
                placeholder="Write your comment..."
                sx={{
                  width: "50%",
                  borderRadius: "27px",
                  backgroundColor: "rgba(255, 255, 255, 0.72)",
                  p: 0.5,
                }}
                size="small"
                variant="standard"
                InputProps={{
                  disableUnderline: true,
                  endAdornment:
                    post?.reacts?.total > 0 ? (
                      <Box
                        sx={{ cursor: "pointer" }}
                        onClick={() =>
                          isAuthenticated && setOpenEmojis(!openEmojis)
                        }
                      >
                        <Box
                          display="flex"
                          width={1}
                          alignContent="center"
                          justifyContent="flex-start"
                        >
                          <Box sx={{ mx: 1 }} alignSelf="center">
                            {post?.reacts?.total}
                          </Box>
                          {currentPostReacts.map((reactId) => {
                            if (reactId === 1) {
                              return (
                                <Box item alignSelf="center" key={reactId}>
                                  <Emoji9 />
                                </Box>
                              );
                            } else
                              return (
                                <Box
                                  item
                                  key={reactId}
                                  sx={{
                                    width: "20px",
                                    display: "grid",
                                    placeItems: "center",
                                  }}
                                >
                                  {postReacts[reactId]?.emoji}
                                </Box>
                              );
                          })}
                        </Box>
                      </Box>
                    ) : (
                      <>
                        {isAuthenticated && (
                          <IconButton
                            size="small"
                            sx={{
                              fill: "#7a7a7a",
                              transition: "0.5s all",
                              "&:hover": {
                                backgroundColor: "transparent",
                                fill: "#25AAE1",
                              },
                            }}
                            onClick={() => setOpenEmojis(!openEmojis)}
                          >
                            <InsertEmoji />
                          </IconButton>
                        )}
                      </>
                    ),
                }}
                value={comment}
                onKeyDown={handleKeyDown}
                onChange={(e) => setComment(e.target.value)}
              />

              <IconButton
                size="small"
                color="primary"
                sx={{
                  width: "40px",
                  height: "40px",
                  minHeight: "fit-content",
                  minWidth: "fit-content",
                  transition: "0.5s all",
                  backgroundColor: "primary.main",
                  stroke: "#000",
                }}
                onClick={handleSendMessage}
              >
                <SendBtn />
              </IconButton>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "end" },
                alignItems: "center",
              }}
            >
              <Stack
                spacing={2}
                direction="row"
                sx={{
                  color: "#fff",
                  width: "200px",
                  alignItems: "center",
                }}
              >
                <VolumeDown />
                <Slider
                  min={0}
                  max={1}
                  step={0.01}
                  aria-label="Volume"
                  value={volume}
                  onChange={handleVolumeChange}
                  sx={{ color: "#fff" }}
                />
                <VolumeUp />
              </Stack>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            fill: "#fff",
            zIndex: 20,
            justifyContent: "space-between",
          }}
        >
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
            }}
          >
            <Button
              size="small"
              sx={{
                width: "20px",
                height: "20px",
                minHeight: "fit-content",
                minWidth: "fit-content",
                transition: "0.5s all",
                "&:hover": {
                  fill: "#25AAE1",
                },
              }}
            >
              <ArrowDown />
            </Button>

            <Button
              size="small"
              sx={{
                width: "20px",
                minHeight: "fit-content",
                minWidth: "fit-content",
                transition: "0.5s all",
                "&:hover": {
                  fill: "#25AAE1",
                },
              }}
            >
              <SortIcon />
            </Button>
          </Box> */}

          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "1em",
              backgroundColor: "rgba(255, 255, 255, 0.68)",
              borderRadius: "5px",
              padding: "0 0.5em",
              height: "35px",
              opacity: openEmojis ? 1 : 0,
              pointerEvents: openEmojis ? 1 : "none",
              transition: "opacity 1s",
              "& > *": {
                width: "25px",
                cursor: "pointer",
                "&:hover": {
                  transform: "scale(1.2)",
                },
              },
            }}
          >
            {reactsIds.map((reactId) => {
              const react = postReacts[reactId];
              return (
                <Box
                  key={reactId}
                  sx={{ mx: 1 }}
                  className="pointer"
                  onClick={() => reactionClicked(reactId)}
                >
                  {react && react?.emoji}
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default Overlay;
